import {
	AutocompleteInput,
	Create,
	ReferenceInput,
	SimpleForm,
	TextInput,
	required,
} from "react-admin";
import { useCreateSubmit } from "../../forms";

export const ChannelCreate = () => {
	return (
		<Create>
			<SimpleForm onSubmit={useCreateSubmit("channels", "Channel created")}>
				<ReferenceInput source="organ_id" reference="organs">
					<AutocompleteInput
						validate={required()}
						optionText="name"
						fullWidth
						disabled
					/>
				</ReferenceInput>
				<TextInput source="name" validate={[required()]} fullWidth />
			</SimpleForm>
		</Create>
	);
};
